export default __webpack_public_path__ + "static/media/US Navy.69406c9d.jpg";